import moment from 'moment';

export const asDate = (value) => {
  if (value instanceof Date) {
    const year = value.getFullYear();
    const month = `${value.getMonth() + 1}`.padStart(2, '0');
    const day = `${value.getDate()}`.padStart(2, '0');

    return `${year}-${month}-${day}`;
  } else if (typeof value === 'string') {
    const theDate = Date.parse(value);

    if (theDate) {
      theDate.toISOString().substring(0, 10);
    }
  }

  return undefined;
};

const today = () => {
  return asDate(new Date());
};

const subtractMonths = (date, value) => {
  const result = moment(date).subtract(value, 'month');
  return asDate(result.toDate());
};

const subtractDays = (date, value) => {
  const result = moment(date).subtract(value, 'day');
  return asDate(result.toDate());
};

const last30Days = () => {
  return subtractDays(today(), 30);
};

const last7Days = () => {
  return subtractDays(today(), 7);
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  asDate,
  today,
  subtractMonths,
  subtractDays,
  last30Days,
  last7Days,
};
